import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppLayoutService } from '@app/modules/app-layout/app-layout.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CompaniesService } from '@services/companies.service';

@Component({
  selector: 'app-company-bond-request-page',
  templateUrl: './company-bond-request-page.component.html',
  styleUrls: ['./company-bond-request-page.component.scss'],
})
export class CompanyBondRequestPageComponent implements OnInit, OnDestroy {
  public hideHeader: boolean = false;

  private isDestroy: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  constructor(
    private appLayoutService: AppLayoutService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private companiesService: CompaniesService,
  ) {}

  public ngOnInit(): void {
    this.appLayoutService.contentHeader$.next({
      title: [
        { key: 'MENU.ACCOUNT_SETTINGS', link: '/companies/account-settings' },
        { key: 'LABELS.IMPORTER_OF_RECORD', link: `/companies/account-settings/company-view/${this.companiesService.getCompany().id}` },
        { key: 'FORM_LABEL.BOND_REQUEST', link: null },
      ],
    });
    if (this.activatedRoute.firstChild && this.activatedRoute.firstChild.snapshot.data) {
      this.hideHeader = !!this.activatedRoute.firstChild.snapshot.data['hideHeader'];
    }
    this.router.events.pipe(takeUntil(this.isDestroy)).subscribe(() => {
      if (this.activatedRoute.firstChild && this.activatedRoute.firstChild.snapshot.data) {
        this.hideHeader = !!this.activatedRoute.firstChild.snapshot.data['hideHeader'];
      }
    });
  }

  public ngOnDestroy(): void {
    this.isDestroy.next(true);
    this.isDestroy.complete();
  }

  public back() {
    this.location.back();
  }
}
